import type { ComponentType, ExoticComponent } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import type { ListChildComponentProps, VariableSizeListProps } from 'react-window';
import { VariableSizeList as List } from 'react-window';
import type { MetricEntry } from '../types';
import { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { MetricChip, MetricInput } from './MetricsComponents';

const VariableSizeList = List as unknown as ComponentType<VariableSizeListProps>;

interface IProps {
  items: MetricEntry[];
}

// eslint-disable-next-line react/display-name
const EditMetricValueListItem: ExoticComponent<ListChildComponentProps<MetricEntry[]>> = memo(
  ({ data, index, style }) => {
    const metric = data[index];

    return (
      <TableRow style={style} sx={{ td: { height: 64, px: 2 } }}>
        <TableCell sx={{ width: 280, minWidth: 280, maxWidth: 280 }}>
          <MetricChip label={metric.name} />
        </TableCell>
        {metric.projects.map((prj, projectIndex) => (
          <TableCell key={`${prj.id}.${prj.value}`}>
            <MetricInput
              name={`items.${index}.projects.${projectIndex}.value`}
              type="number"
              style={{ width: 75, height: 38, padding: '8px 12px' }}
            />
          </TableCell>
        ))}
      </TableRow>
    );
  }
);

// eslint-disable-next-line react/display-name
const EditMetricValueList: ExoticComponent<IProps> = memo(({ items }) => {
  return (
    <AutoSizer>
      {({ height, width }) => (
        <VariableSizeList height={height} itemCount={items.length} itemSize={() => 64} width={width} itemData={items}>
          {/*falls locally, but fine in pipeline*/}
          {EditMetricValueListItem as any}
        </VariableSizeList>
      )}
    </AutoSizer>
  );
});

export default EditMetricValueList;
